// Timezone and currency choices shared by the sign-up wizard and Settings, so the two
// can't disagree. (They did: the wizard offered NZD, which Settings couldn't display,
// and Settings offered Pacific/Auckland, which the wizard didn't.)

export const TIMEZONES = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Phoenix', 'America/Los_Angeles',
  'America/Anchorage', 'Pacific/Honolulu', 'America/Toronto', 'America/Vancouver', 'America/Halifax',
  'America/Mexico_City', 'America/Sao_Paulo', 'Europe/London', 'Europe/Dublin', 'Europe/Paris',
  'Europe/Berlin', 'Europe/Madrid', 'Europe/Rome', 'Europe/Amsterdam', 'Africa/Johannesburg',
  'Asia/Dubai', 'Asia/Kolkata', 'Asia/Singapore', 'Asia/Hong_Kong', 'Asia/Shanghai', 'Asia/Tokyo',
  'Australia/Perth', 'Australia/Sydney', 'Pacific/Auckland',
];

export const CURRENCIES = ['USD', 'CAD', 'GBP', 'EUR', 'AUD', 'NZD'];

const EURO_REGIONS = ['IE', 'DE', 'FR', 'ES', 'IT', 'NL', 'BE', 'AT', 'PT', 'FI', 'GR', 'LU'];
const REGION_CURRENCY = { US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD' };

// The browser's own timezone, e.g. 'America/Chicago'. Falls back to Eastern, the old default.
export function detectTimezone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York'; }
  catch { return 'America/New_York'; }
}

// A guess from the browser's language region ('en-GB' -> GBP). USD when we can't tell.
export function detectCurrency() {
  try {
    const region = (navigator.language || '').split('-')[1]?.toUpperCase();
    if (!region) return 'USD';
    if (EURO_REGIONS.includes(region)) return 'EUR';
    return REGION_CURRENCY[region] || 'USD';
  } catch { return 'USD'; }
}

// The list with the current value included, so a saved or detected value outside the
// curated list still shows as itself instead of silently displaying the first option.
const withCurrent = (list, current) => (current && !list.includes(current) ? [current, ...list] : list);
export const tzOptions       = (current) => withCurrent(TIMEZONES, current);
export const currencyOptions = (current) => withCurrent(CURRENCIES, current);

// 'America/New_York' -> 'America/New York'
export const tzLabel = (tz) => (tz || '').replace(/_/g, ' ');
